import { Search, Filter } from 'lucide-react'
import { Input } from '@/components/ui/input'
import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from '@/components/ui/select'
import { ADMIN_USER_ROLE_OPTIONS } from '@/types/adminUser'
import type { UserRole } from '@/types/adminUser'

interface AdminUsersFiltersProps {
  searchInput: string
  onSearchChange: (value: string) => void
  roleFilter: UserRole | 'all'
  onRoleFilterChange: (value: UserRole | 'all') => void
}

export function AdminUsersFilters({
  searchInput,
  onSearchChange,
  roleFilter,
  onRoleFilterChange,
}: AdminUsersFiltersProps) {
  return (
    <div className="flex items-center gap-3 rounded-lg border border-border bg-card p-3">
      {/* Search Input */}
      <div className="relative flex-1 max-w-[352px]">
        <Search className="absolute left-3 top-1/2 h-4 w-4 -translate-y-1/2 text-muted-foreground" />
        <Input
          placeholder="Search users..."
          value={searchInput}
          onChange={e => onSearchChange(e.target.value)}
          className="pl-9 bg-muted/50"
        />
      </div>

      {/* Filter Icon */}
      <Filter className="h-6 w-6 text-muted-foreground" />

      {/* Role Filter */}
      <Select
        value={roleFilter}
        onValueChange={value => onRoleFilterChange(value as UserRole | 'all')}
      >
        <SelectTrigger className="w-[150px]">
          <SelectValue />
        </SelectTrigger>
        <SelectContent>
          {ADMIN_USER_ROLE_OPTIONS.map(option => (
            <SelectItem key={option.value} value={option.value}>
              {option.label}
            </SelectItem>
          ))}
        </SelectContent>
      </Select>
    </div>
  )
}
